import { render, staticRenderFns } from "./associationListNew.vue?vue&type=template&id=99d28f0a&scoped=true"
import script from "./associationListNew.vue?vue&type=script&lang=js"
export * from "./associationListNew.vue?vue&type=script&lang=js"
import style0 from "./associationListNew.vue?vue&type=style&index=0&id=99d28f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d28f0a",
  null
  
)

export default component.exports